/**
 * Component: Typewriter
 *
 * Description:
 * This component animates a given string (`text`) using a typewriter effect.
 * Words are typed one character at a time with configurable delays.
 *
 * Usage:
 * <Typewriter text="Welcome to the AI-powered experience." />
 *
 * Styles:
 * The blinking cursor and text animation are styled via `Typewriter.css`.
 */

import React, { useState, useEffect } from "react";
import "./Typewriter.css"; // Import CSS for text animation and cursor

const Typewriter = ({ text }) => {
  const [displayedText, setDisplayedText] = useState(""); // Text shown on screen

  useEffect(() => {
    let currentText = ""; // Running text as it builds
    const words = text.split(" "); // Split input text by words
    let wordIndex = 0; // Current word being typed

    // Recursive function to type each word
    const typeWord = () => {
      if (wordIndex < words.length) {
        const word = words[wordIndex];
        let charIndex = 0;

        // Recursive function to type each character of a word
        const typeChar = () => {
          if (charIndex < word.length) {
            currentText += word[charIndex++];
            setDisplayedText(currentText);
            setTimeout(typeChar, 40); // Delay between characters
          } else {
            currentText += " "; // Add space after each word
            wordIndex++;
            setTimeout(typeWord, 80); // Delay between words
          }
        };

        typeChar(); // Start typing current word
      }
    };

    typeWord(); // Begin typing process on mount
  }, [text]); // Re-run effect if the input text changes

  return (
    <div className="typewriter-box">
      {displayedText}
      <span className="cursor"></span> {/* Blinking cursor at end of text */}
    </div>
  );
};

export default Typewriter;
